/* Eva Juwelier – Wunschliste (lokal im Browser gespeichert) */
(function () {
  if (window.evaWishlistInit) return;
  window.evaWishlistInit = true;

  var KEY = 'eva_wishlist';
  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var T = {
    de: { add: 'Zur Wunschliste hinzufügen', added: 'Auf Ihrer Wunschliste', aria: 'Wunschliste', title: 'Ihre Wunschliste',
          empty: 'Ihre Wunschliste ist noch leer. Klicken Sie bei einem Schmuckstück auf das Herz, um es hier zu speichern.',
          shop: 'Schmuck entdecken', remove: 'Entfernen', view: 'Ansehen', sold: 'Ausverkauft',
          cart: 'In den Warenkorb', size: 'Größe wählen', adding: 'Wird hinzugefügt …', inCart: 'Im Warenkorb ✓', err: 'Leider nicht möglich',
          ringSize: 'Ringgröße', chainLen: 'Kettenlänge', pick: 'Bitte Größe wählen', other: 'Andere Größe' },
    en: { add: 'Add to wishlist', added: 'On your wishlist', aria: 'Wishlist', title: 'Your wishlist',
          empty: 'Your wishlist is empty. Tap the heart on any piece to save it here.',
          shop: 'Discover jewellery', remove: 'Remove', view: 'View', sold: 'Sold out',
          cart: 'Add to cart', size: 'Choose size', adding: 'Adding …', inCart: 'In your cart ✓', err: 'Not possible',
          ringSize: 'Ring size', chainLen: 'Necklace length', pick: 'Please select a size', other: 'Other size' },
    tr: { add: 'İstek listesine ekle', added: 'İstek listenizde', aria: 'İstek listesi', title: 'İstek listeniz',
          empty: 'İstek listeniz henüz boş. Kaydetmek için bir üründeki kalbe dokunun.',
          shop: 'Mücevherleri keşfedin', remove: 'Kaldır', view: 'Görüntüle', sold: 'Tükendi',
          cart: 'Sepete ekle', size: 'Ölçü seçin', adding: 'Ekleniyor …', inCart: 'Sepette ✓', err: 'Mümkün değil',
          ringSize: 'Yüzük ölçüsü', chainLen: 'Kolye uzunluğu', pick: 'Lütfen ölçü seçin', other: 'Başka ölçü' }
  };
  T = T[lang] || T.de;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.4C1.5 7.9 3.6 4.5 7 4.5c2 0 3.6 1.1 5 2.9 1.4-1.8 3-2.9 5-2.9 3.4 0 5.5 3.4 4.3 6.6-1.8 4.8-9.3 9.4-9.3 9.4z"/></svg>';

  var mem = [];
  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return mem.slice(); }
  }
  function save(list) {
    mem = list.slice();
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    refresh();
  }
  function toggle(h) {
    var l = load(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    save(l);
  }
  function handleFrom(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  var css = document.createElement('style');
  css.textContent =
    '.eva-wl-heart{position:absolute;top:1rem;right:1rem;z-index:5;width:3.8rem;height:3.8rem;border-radius:50%;border:0;background:rgba(255,255,255,.92);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 1px 4px rgba(0,0,0,.08);transition:transform .15s}' +
    '.eva-wl-heart:hover{transform:scale(1.08)}' +
    '.eva-wl-heart svg,.eva-wl-btn svg{width:2rem;height:2rem;fill:none;stroke:#1a1a1a;stroke-width:1.5}' +
    '.eva-wl-icon svg{width:2.2rem;height:2.2rem;fill:none;stroke:currentColor;stroke-width:1.5}' +
    '.eva-wl-heart.is-on svg,.eva-wl-btn.is-on svg,.eva-wl-icon.is-on svg{fill:#a8843f;stroke:#a8843f}' +
    '.eva-wl-btn{display:flex;align-items:center;justify-content:center;gap:1rem;width:100%;min-height:5rem;margin:1rem 0 0;background:#fff;color:#1a1a1a;border:1px solid rgba(26,26,26,.35);font:inherit;font-size:1.25rem;letter-spacing:.2em;text-transform:uppercase;cursor:pointer}' +
    '.eva-wl-btn:hover{border-color:#1a1a1a}' +
    '.eva-wl-icon{position:relative;color:#1a1a1a}' +
    '.eva-wl-icon .eva-wl-count{position:absolute;top:auto;right:auto;bottom:.8rem;left:2.2rem;width:auto;min-width:1.7rem;height:1.7rem!important;max-height:1.7rem;border-radius:1rem;background:#a8843f;color:#fff;font-size:.9rem;line-height:1.7rem;text-align:center;padding:0 .4rem;display:block;box-sizing:border-box}' +
    '.eva-wl-icon .eva-wl-count[hidden]{display:none}' +
    '#eva-wishlist{margin:2rem 0 4rem}' +
    '.eva-wl-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:2.4rem}' +
    '@media screen and (max-width:989px){.eva-wl-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}' +
    '@media screen and (max-width:749px){.eva-wl-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:1.4rem}}' +
    '.eva-wl-item{position:relative;display:flex;flex-direction:column}' +
    '.eva-wl-item a.eva-wl-img{display:block;aspect-ratio:1/1;background:#f6f4f0;overflow:hidden}' +
    '.eva-wl-item img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.eva-wl-item h3{font-size:1.4rem;font-weight:400;letter-spacing:.03em;margin:1.2rem 0 .4rem;line-height:1.35}' +
    '.eva-wl-item h3 a{color:#1a1a1a;text-decoration:none}' +
    '.eva-wl-price{font-size:1.3rem;margin:0 0 1rem;color:rgba(26,26,26,.8)}' +
    '.eva-wl-actions{display:flex;gap:.8rem;margin-top:auto}' +
    '.eva-wl-actions a,.eva-wl-actions button{flex:1;min-height:4rem;display:flex;align-items:center;justify-content:center;font:inherit;font-size:1.1rem;letter-spacing:.15em;text-transform:uppercase;text-decoration:none;cursor:pointer}' +
    '.eva-wl-actions a,.eva-wl-actions button{background:#fff;color:#1a1a1a!important;border:1px solid rgba(26,26,26,.35)}' +
    '.eva-wl-cart{display:flex;align-items:center;justify-content:center;width:100%;min-height:4.4rem;margin-top:.8rem;background:#1a1a1a;color:#fff!important;border:0;font:inherit;font-size:1.1rem;letter-spacing:.15em;text-transform:uppercase;text-decoration:none!important;cursor:pointer}' +
    '.eva-wl-cart.is-sold{background:rgba(26,26,26,.35);cursor:default}' +
    '.eva-qa{position:relative;z-index:5;display:flex;flex-direction:column;gap:.6rem;margin-top:1rem}' +
    '.eva-qa select{width:100%;min-height:4rem;padding:0 3.2rem 0 1.2rem;font:inherit;font-size:1.2rem;color:#1a1a1a;background:#fff url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 6%27><path d=%27M1 1l4 4 4-4%27 fill=%27none%27 stroke=%27%231a1a1a%27/></svg>") no-repeat right 1.2rem center/1rem;border:1px solid rgba(26,26,26,.3);border-radius:0;appearance:none;-webkit-appearance:none;cursor:pointer}' +
    '.eva-qa select.is-error{border-color:#8e1b14}' +
    '.eva-qa .eva-wl-cart{margin-top:0}' +
    '@media screen and (max-width:749px){.eva-qa .eva-wl-cart{font-size:1rem;letter-spacing:.08em;min-height:4rem}.eva-qa select{font-size:1.1rem}}' +
    '.eva-wl-empty{text-align:center;padding:3rem 0}' +
    '.eva-wl-empty a{display:inline-block;margin-top:1.6rem;padding:1.4rem 3rem;background:#1a1a1a;color:#fff;text-decoration:none;letter-spacing:.2em;text-transform:uppercase;font-size:1.2rem}';
  document.head.appendChild(css);

  /* Herz-Symbol im Header */
  function addHeaderIcon() {
    if (document.querySelector('.eva-wl-icon')) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var a = document.createElement('a');
    a.href = root + 'pages/wunschliste';
    a.className = 'header__icon link focus-inset eva-wl-icon';
    a.setAttribute('aria-label', T.aria);
    a.innerHTML = '<span class="svg-wrapper">' + HEART + '</span><span class="eva-wl-count" hidden></span>';
    var before = icons.querySelector('.header__icon--account, account-popover, .header__icon--cart');
    if (before && before.parentNode === icons) icons.insertBefore(a, before);
    else icons.insertBefore(a, icons.firstChild);
  }

  /* Herzen auf Produktkarten (direkt an der Karte, damit der Produktlink sie nicht verdeckt) */
  function addCardHearts() {
    var cards = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.querySelector('.eva-wl-heart')) continue;
      var link = c.querySelector('a[href*="/products/"]');
      var h = link && handleFrom(link.getAttribute('href'));
      if (!h) continue;
      if (getComputedStyle(c).position === 'static') c.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'eva-wl-heart';
      b.setAttribute('data-eva-wl', h);
      b.innerHTML = HEART;
      c.appendChild(b);
    }
  }

  /* Button auf der Produktseite */
  function addProductButton() {
    var h = handleFrom(location.pathname);
    if (!h) return;
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.eva-wl-btn')) return;
    var anchor = info.querySelector('.product-form__buttons') || info.querySelector('product-form');
    if (!anchor) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'eva-wl-btn';
    b.setAttribute('data-eva-wl', h);
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
  }

  function refresh() {
    var list = load();
    var btns = document.querySelectorAll('[data-eva-wl]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], on = list.indexOf(b.getAttribute('data-eva-wl')) > -1;
      if (b.getAttribute('data-state') === String(on)) continue;
      b.setAttribute('data-state', String(on));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.added : T.add);
      if (b.classList.contains('eva-wl-btn')) b.innerHTML = HEART + '<span>' + (on ? T.added : T.add) + '</span>';
    }
    var icons = document.querySelectorAll('.eva-wl-icon');
    for (var j = 0; j < icons.length; j++) {
      icons[j].classList.toggle('is-on', list.length > 0);
      var n = icons[j].querySelector('.eva-wl-count');
      if (n.textContent !== String(list.length)) n.textContent = list.length;
      n.hidden = list.length === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-eva-wl],[data-eva-rm]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-eva-wl') || b.getAttribute('data-eva-rm'));
    if (b.hasAttribute('data-eva-rm') && document.getElementById('eva-wishlist')) renderPage();
  }, true);

  /* Wunschliste-Seite */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    try { return new Intl.NumberFormat(lang === 'en' ? 'de-DE' : lang + '-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  /* Warenkorb-Button: Ringe und Ketten brauchen eine Größe, daher geht es dort zur Produktseite */
  function needsSize(p) {
    var t = String(p.type || '').toLowerCase().trim();
    return ['ring', 'ringe', 'halskette', 'halsketten', 'kette'].indexOf(t) > -1;
  }
  function cartBtn(p, url) {
    if (!p.available) return '<button type="button" class="eva-wl-cart is-sold" disabled>' + esc(T.sold) + '</button>';
    if (needsSize(p)) return '<a class="eva-wl-cart" href="' + url + '">' + esc(T.size) + '</a>';
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return '<button type="button" class="eva-wl-cart is-sold" disabled>' + esc(T.sold) + '</button>';
    return '<button type="button" class="eva-wl-cart" data-eva-cart="' + v.id + '">' + esc(T.cart) + '</button>';
  }
  function addToCart(btn, props) {
    var id = btn.getAttribute('data-eva-cart');
    btn.disabled = true; btn.textContent = T.adding;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [props ? { id: Number(id), quantity: 1, properties: props } : { id: Number(id), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        btn.textContent = T.inCart;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && d.sections && d.sections['cart-drawer']) {
          try {
            d.id = d.items && d.items[0] ? d.items[0].id : null;
            drawer.classList.remove('is-empty');
            drawer.renderContents(d);
            setTimeout(function () { btn.disabled = false; btn.textContent = T.cart; }, 2500);
            return;
          } catch (err) {}
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && d.sections && d.sections['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = d.sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp;
          bubble.innerHTML = inner.innerHTML;
        }
        setTimeout(function () { btn.disabled = false; btn.textContent = T.cart; }, 2500);
      })
      .catch(function () {
        btn.textContent = T.err;
        setTimeout(function () { btn.disabled = false; btn.textContent = T.cart; }, 2500);
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-eva-cart]');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var box = b.closest('.eva-qa'), sel = box && box.querySelector('select');
    if (sel) {
      if (!sel.value) { sel.classList.add('is-error'); sel.focus(); return; }
      if (sel.hasAttribute('data-variant')) { b.setAttribute('data-eva-cart', sel.value); addToCart(b); return; }
      if (sel.value === '__other') { location.href = box.getAttribute('data-url'); return; }
      var p = {}; p[sel.getAttribute('data-prop')] = sel.value;
      addToCart(b, p);
    } else addToCart(b);
  }, true);

  /* Warenkorb-Button auf Kategorie- und Suchseiten (nicht auf der Startseite) */
  function listingPage() {
    var m = document.querySelector('main[data-template]');
    var t = m ? m.getAttribute('data-template') : '';
    return /^(collection|search)/.test(t);
  }
  var pcache = {};
  function getProduct(h) {
    if (!pcache[h]) pcache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return pcache[h];
  }
  function sizeKind(p) {
    var t = String(p.type || '').toLowerCase().trim();
    if (t === 'ring' || t === 'ringe') return 'ring';
    if (t === 'halskette' || t === 'halsketten' || t === 'kette') return 'kette';
    return '';
  }
  function addCardCart() {
    if (!listingPage()) return;
    var cards = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) (function (c) {
      if (c.getAttribute('data-eva-qa')) return;
      var link = c.querySelector('a[href*="/products/"]');
      var h = link && handleFrom(link.getAttribute('href'));
      if (!h) return;
      c.setAttribute('data-eva-qa', '1');
      getProduct(h).then(function (p) {
        if (!p || c.querySelector('.eva-qa')) return;
        var url = root + 'products/' + p.handle;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        var box = document.createElement('div');
        box.className = 'eva-qa';
        box.setAttribute('data-url', url);
        if (!p.available || !v) {
          box.innerHTML = '<button type="button" class="eva-wl-cart is-sold" disabled>' + esc(T.sold) + '</button>';
        } else {
          var kind = sizeKind(p), html = '';
          var avail = (p.variants || []).filter(function (x) { return x.available; });
          if (p.variants && p.variants.length > 1) {
            var vopts = '';
            p.variants.forEach(function (x) { vopts += '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' – ' + esc(T.sold)) + '</option>'; });
            var oname = (p.options && p.options[0] && (p.options[0].name || p.options[0])) || T.size;
            html += '<select data-variant aria-label="' + esc(oname) + '"><option value="">' + esc(oname) + ' – ' + esc(T.size) + '</option>' + vopts + '</select>';
            kind = '';
          } else if (kind) {
            var opts = '';
            if (kind === 'ring') { for (var s = 48; s <= 64; s++) opts += '<option value="' + s + '">' + s + '</option>'; }
            else { ['38', '40', '42', '45', '50', '55', '60'].forEach(function (s) { opts += '<option value="' + s + ' cm">' + s + ' cm</option>'; }); }
            html += '<select aria-label="' + esc(kind === 'ring' ? T.ringSize : T.chainLen) + '" data-prop="' + (kind === 'ring' ? 'Ringgröße' : 'Kettenlänge') + '">' +
              '<option value="">' + esc(kind === 'ring' ? T.ringSize : T.chainLen) + ' – ' + esc(T.size) + '</option>' + opts +
              '<option value="__other">' + esc(T.other) + ' …</option></select>';
          }
          html += '<button type="button" class="eva-wl-cart" data-eva-cart="' + v.id + '">' + esc(T.cart) + '</button>';
          box.innerHTML = html;
          var sel = box.querySelector('select');
          if (sel) sel.addEventListener('change', function () { sel.classList.remove('is-error'); });
        }
        var infos = c.querySelectorAll('.card__information');
        var target = infos.length ? infos[infos.length - 1] : (c.querySelector('.card__content') || c);
        target.appendChild(box);
      });
    })(cards[i]);
  }

  function renderPage() {
    var box = document.getElementById('eva-wishlist');
    if (!box) return;
    var list = load();
    if (!list.length) {
      box.innerHTML = '<div class="eva-wl-empty"><p>' + esc(T.empty) + '</p><a href="' + root + 'collections/all">' + esc(T.shop) + '</a></div>';
      return;
    }
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = '<div class="eva-wl-grid">';
      items.forEach(function (p) {
        if (!p) return;
        var url = root + 'products/' + p.handle;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        html += '<div class="eva-wl-item"><a class="eva-wl-img" href="' + url + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="eva-wl-heart" data-eva-rm="' + esc(p.handle) + '" aria-label="' + esc(T.remove) + '">' + HEART + '</button>' +
          '<h3><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
          '<p class="eva-wl-price">' + (p.available ? money(p.price) : esc(T.sold)) + '</p>' +
          '<div class="eva-wl-actions"><a href="' + url + '">' + esc(T.view) + '</a><button type="button" data-eva-rm="' + esc(p.handle) + '">' + esc(T.remove) + '</button></div>' +
          cartBtn(p, url) + '</div>';
      });
      html += '</div>';
      box.innerHTML = html;
      var hs = box.querySelectorAll('.eva-wl-heart');
      for (var k = 0; k < hs.length; k++) hs[k].classList.add('is-on');
    });
  }

  function init() { addHeaderIcon(); addCardHearts(); addProductButton(); addCardCart(); refresh(); }
  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(init, 150); }

  function start() {
    mem = load();
    init();
    renderPage();
    try { new MutationObserver(later).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('storage', function (e) { if (e.key === KEY) { refresh(); renderPage(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
